import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, FileText, CheckCircle } from 'lucide-react';
import Header from '../components/Header';

export default function AboutUs() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header />

      <div className="pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate('/')}
            className="mb-8"
            data-testid="back-button"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Button>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-card border border-border rounded-lg p-8"
          >
            <h1 className="text-4xl font-heading font-bold mb-6">About Us</h1>

            <div className="space-y-6 text-foreground">
              <p className="text-lg leading-relaxed">
                Welcome to <strong>MyTestCase</strong> (accessible via{' '}
                <a href="https://mytestcase.com" className="text-blue-500 hover:underline">
                  https://mytestcase.com
                </a>
                )—we offer utilities for Quality Assurance.
              </p>

              <div className="mt-8">
                <h2 className="text-2xl font-heading font-semibold mb-4">What We Offer</h2>

                <div className="space-y-4">
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.2 }}
                    className="flex items-start gap-4 p-4 bg-secondary/30 rounded-lg border border-border"
                  >
                    <FileText className="h-6 w-6 text-blue-500 shrink-0 mt-1" />
                    <div>
                      <h3 className="text-lg font-semibold mb-2">Test Case Generation</h3>
                      <p className="text-muted-foreground">
                        We generate test cases in CSV format based on your inputs. These CSV files are compatible with Azure DevOps and JIRA.
                      </p>
                    </div>
                  </motion.div>

                  {/* "More Utilities Coming Soon" section removed */}
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
